import type { TLatestNewsItem } from './latestNewsStorage';

/** 富文字是否視為空白（僅標籤／空白） */
export function isLatestNewsContentHtmlEmpty(html: string): boolean {
  const raw = (html ?? '').trim();
  if (!raw) return true;
  if (typeof document === 'undefined') {
    const text = raw.replace(/<[^>]+>/g, '').replace(/&nbsp;/gi, ' ');
    return text.trim().length === 0;
  }
  try {
    const doc = new DOMParser().parseFromString(raw, 'text/html');
    return (doc.body.textContent || '').trim().length === 0;
  } catch {
    return true;
  }
}

export const LATEST_NEWS_TITLE_MAX_LEN = 53;

/**
 * 送出前必填檢查。
 * 回傳一則或多則短句，呼叫端以「、」串成紅字訊息。
 */
export function getLatestNewsRequiredViolations(
  draft: TLatestNewsItem,
): string[] {
  const out: string[] = [];

  if (isLatestNewsContentHtmlEmpty(draft.contentHtml)) {
    out.push('請填寫內文');
  }

  if (draft.title.trim().length > LATEST_NEWS_TITLE_MAX_LEN) {
    out.push(`標題不可超過 ${LATEST_NEWS_TITLE_MAX_LEN} 個字`);
  }

  const day = draft.publishedAt?.trim() ?? '';
  if (day.length < 10) {
    out.push('請選擇上架日期');
  }

  if (!draft.eduCodes.length) out.push('請選擇學程');
  if (!draft.subjects.some(s => s.trim())) out.push('請選擇科目');
  if (!draft.schoolYears.some(s => s.trim())) out.push('請選擇學年度');
  if (!draft.grades.some(s => s.trim())) out.push('請選擇年級（冊次）');

  return out;
}
